import { useStaticQuery, graphql } from 'gatsby'

export const useResearchApiData = () => {
  const data = graphql`
    {
      researchApi {
        values {
          lang
          pages {
            slug
            excerpt {
              rendered
            }
            title {
              rendered
            }
            content {
              rendered
            }
            yoast_head {
              json {
                article_modified_time
                canonical
                description
                og_description
                og_locale
                og_site_name
                og_title
                og_type
                og_url
                robots {
                  follow
                  index
                  max_image_preview
                  max_snippet
                  max_video_preview
                }
                title
                twitter_card
                twitter_misc {
                  Est__reading_time
                  Est__tempo_de_leitura
                }
                schema
                og_image {
                  url
                }
              }
            }
          }
        }
      }
    }
  `

  const response = useStaticQuery(data)

  const {
    researchApi: { values },
  } = response

  const pages = values?.[0]?.pages || []

  return { pages }
}
